/**
 * What to tell the user when turning the camera on failed. getUserMedia
 * rejects with a DOMException whose name says why; livekit-client passes it
 * through `setCameraEnabled` unchanged. Older Chromium spellings are kept.
 */
export function cameraErrorMessage(error: unknown): string {
  const name = (error as { name?: unknown } | null)?.name;
  switch (name) {
    case 'NotAllowedError':
    case 'PermissionDeniedError':
    case 'SecurityError':
      return 'Camera access is blocked. Allow TeamLio to use the camera in your system or browser settings, then try again.';
    case 'NotFoundError':
    case 'DevicesNotFoundError':
    case 'OverconstrainedError':
      return 'No camera was found. Connect a camera and try again.';
    case 'NotReadableError':
    case 'TrackStartError':
      return 'The camera is in use by another app. Close it and try again.';
    default:
      return 'Could not turn on the camera. Try again.';
  }
}
